/**
 * @file Mobile Menu.
 */

import debounce from 'just-debounce-it';
import { gsap } from 'gsap';

/**
 * Mobile Menu component.
 */
const vMobileMenu = () => {
	const mobileMenu = document.querySelector('.v-mobile-menu');

	if (!mobileMenu) {
		return;
	}

	const header = document.querySelector('.v-header');
	const mobileTrigger = header.querySelector('.v-header__mobile-nav-trigger');
	let isOpen = false;
	let headerTl;

	const isReversed = header.classList.contains('v-header--reversed');

	gsap.set('.v-mobile-menu__background', {
		transformOrigin: 'right center',
		scaleX: 0,
	});

	gsap.set('.v-mobile-menu__wrap', {
		opacity: 0,
	});

	gsap.set('.v-mobile-menu__overlay', {
		opacity: 0,
	});

	const subnavTriggers = document.querySelectorAll(
		'.v-mobile-menu__item--has-children > a',
	);
	const subSubnavTriggers = document.querySelectorAll(
		'.v-mobile-menu__subitem--has-children > a',
	);
	let subnavTl;
	let subSubnavTl;
	let subSubnavTlCb;

	const navScroller = document.querySelector('.v-mobile-menu__nav');
	const subnavs = document.querySelectorAll('.v-mobile-menu__sublist');
	// let navVisibleHeight = 0;
	// let navScrollableHeight = 0;
	const subnavScrollingData = {};

	/**
	 * Set heights for scroll.
	 */
	const setHeights = () => {
		// navVisibleHeight = navScroller.offsetHeight;
		// navScrollableHeight = navScroller.scrollHeight;
		[...subnavs].forEach((subnav, i) => {
			if (!subnavScrollingData[i]) {
				subnavScrollingData[i] = {};
			}
			subnavScrollingData[i].visibleHeight = subnav.offsetHeight;
			subnavScrollingData[i].scrollableHeight = subnav.scrollHeight;
		});
	};
	setHeights();
	window.addEventListener('resize', debounce(setHeights, 200, true));

	/**
	 * Set classes for scroll indicators.
	 */
	/* const setScrollIndicators = () => {
		if (subnavTl) return;
		const scrollPos = navScroller.scrollTop;
		if (scrollPos > 10) {
			navScroller.classList.add('v-can-scroll-up');
		} else {
			navScroller.classList.remove('v-can-scroll-up');
		}

		if (scrollPos + navVisibleHeight < navScrollableHeight - 10) {
			navScroller.classList.add('v-can-scroll-down');
		} else {
			navScroller.classList.remove('v-can-scroll-down');
		}
	}; */
	// setScrollIndicators();
	// navScroller.addEventListener('scroll', setScrollIndicators);
	// window.addEventListener('resize', debounce(setScrollIndicators, 200, true));

	[...subnavs].forEach((subnav, i) => {
		subnavScrollingData[i].setScrollIndicators = () => {
			if (
				subnavTl &&
				!subnavTl
					.getChildren()
					.some(
						(t) => t.targets().filter((e) => e === subnav.parentNode).length,
					)
			) {
				return;
			}
			const scrollPos = subnav.scrollTop;
			if (scrollPos > 10) {
				subnav.classList.add('v-can-scroll-up');
			} else {
				subnav.classList.remove('v-can-scroll-up');
			}

			if (
				scrollPos + subnavScrollingData[i].visibleHeight <
				subnavScrollingData[i].scrollableHeight - 10
			) {
				subnav.classList.add('v-can-scroll-down');
			} else {
				subnav.classList.remove('v-can-scroll-down');
			}
		};

		/* subnavScrollingData[i].setScrollIndicators();
		subnav.addEventListener(
			'scroll',
			subnavScrollingData[i].setScrollIndicators,
		);
		window.addEventListener(
			'resize',
			debounce(subnavScrollingData[i].setScrollIndicators, 200, true),
		); */
	});

	[...subnavTriggers].forEach((trigger) => {
		const subnav = trigger.parentNode.querySelector('.v-mobile-menu__subwrap');
		const back = subnav.querySelector('.v-mobile-menu__back');

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			if (!subnavTl) {
				gsap.set(subnav, { display: 'flex', opacity: 0 });
				setHeights();
				/* [...subnavs].forEach((s, i) => {
					subnavScrollingData[i].setScrollIndicators();
				}); */

				subnavTl = gsap
					.timeline({
						defaults: {
							ease: 'sine.out',
							duration: 0.3,
						},
						onReverseComplete: () => {
							subnavTl.kill();
							gsap.set(subnav, { clearProps: 'all' });
							subnavTl = null;
						},
					})
					.to(
						'.v-mobile-menu__item > .v-mobile-menu__link, .v-mobile-menu__search, .v-header__logo-link, .v-header__cta',
						{
							opacity: 0,
							onStart() {
								navScroller.classList.remove(
									'v-can-scroll-up',
									'v-can-scroll-down',
								);
							},
							onComplete() {
								gsap.set(this.targets(), { pointerEvents: 'none' });
								gsap.set('.v-mobile-menu__nav', {
									overflowY: 'hidden',
									paddingRight: 'var(--scrollbar-width)',
								});
							},
							onReverseComplete() {
								gsap.set(this.targets(), { pointerEvents: 'all' });
								gsap.set('.v-mobile-menu__nav', {
									overflowY: 'scroll',
									clearProps: 'padding-right',
								});
								setHeights();
								// setScrollIndicators();
							},
						},
					)
					.to(
						subnav,
						{
							xPercent: -100,
						},
						'>',
					)
					.to(
						subnav,
						{
							opacity: 1,
						},
						'<+50%',
					);
			}
		});

		back.addEventListener('click', () => {
			if (subnavTl) {
				subnavTl.reverse();
			}
		});
	});

	[...subSubnavTriggers].forEach((trigger) => {
		const subnav = trigger.parentNode.querySelector('.v-mobile-menu__subwrap');
		const parentSub = trigger.closest('.v-mobile-menu__subwrap');
		const parentItems = parentSub.querySelectorAll(
			':scope > .v-mobile-menu__sublist > .v-mobile-menu__subitem > .v-mobile-menu__link, :scope > .v-mobile-menu__subtitle',
		);
		const back = subnav.querySelector('.v-mobile-menu__back');

		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			if (!subSubnavTl) {
				gsap.set(subnav, { display: 'flex', opacity: 0 });
				setHeights();
				/* [...subnavs].forEach((s, i) => {
					subnavScrollingData[i].setScrollIndicators();
				}); */
				subSubnavTl = gsap
					.timeline({
						defaults: {
							ease: 'sine.out',
							duration: 0.3,
						},
						onReverseComplete: () => {
							if (subSubnavTlCb && typeof subSubnavTlCb === 'function') {
								subSubnavTlCb();
								subSubnavTlCb = null;
							}

							subSubnavTl.kill();
							gsap.set(subnav, { clearProps: 'all' });
							subSubnavTl = null;
						},
					})
					.to(parentItems, {
						opacity: 0,
						onStart: () => {
							parentSub
								.querySelector(':scope > .v-mobile-menu__sublist')
								.classList.remove('v-can-scroll-up', 'v-can-scroll-down');
						},
						onComplete: () => {
							gsap.set(parentItems, { pointerEvents: 'none' });
						},
						onReverseComplete: () => {
							gsap.set(parentItems, { pointerEvents: 'all' });
							setHeights();
							/* [...subnavs].forEach((s, i) => {
								subnavScrollingData[i].setScrollIndicators();
							}); */
						},
					})
					.to(
						subnav,
						{
							xPercent: -100,
						},
						'>',
					)
					.to(
						subnav,
						{
							opacity: 1,
						},
						'<+50%',
					);
			}
		});

		back.addEventListener('click', () => {
			if (subSubnavTl) {
				subSubnavTl.reverse();
			}
		});
	});

	const mm = gsap.matchMedia();

	/**
	 * Mobile Menu.
	 * @returns {Function} - Cleanup function.
	 */
	const mobileMenuHandler = () => {
		/**
		 * Generate header tl.
		 * @returns {gsap.core.Timeline} Header timeline.
		 */
		const generateHeaderTl = () =>
			gsap
				.timeline({
					defaults: {
						ease: 'sine.out',
						duration: 0.3,
					},
					paused: true,
					onReverseComplete: () => {
						mobileMenu.classList.remove('v-mobile-menu--open');

						if (headerTl) {
							headerTl.kill();
						}
						headerTl = null;

						if (gsap.getProperty('body', 'position') === 'fixed') {
							const scrollY = gsap.getProperty('body', 'top');
							gsap.set('body', {
								position: '',
								top: '',
								overflowY: '',
							});
							window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
						}

						const e = new CustomEvent('v-mobile-menu-toggle', {
							detail: {
								open: isOpen,
							},
						});
						window.dispatchEvent(e);
					},
				})
				.addLabel('start')
				.to('.v-mobile-menu__background', {
					scaleX: 1,
					duration: 0.4,
				})
				.addLabel('background-in', '>')
				.to(
					header,
					{
						'--link-default': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--link-hover': '#fff',
						'--contrast-link': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--contrast-link-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link-hover',
						),
						'--cta-text': gsap.getProperty(header, '--header-mobile-nav-link'),
						'--cta-text-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link-hover',
						),
						'--cta-background': 'transparent',
						'--cta-background-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--cta-border': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--cta-border-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--cta-default': 0,
						'--outline-cta-text': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--outline-cta-text-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link-hover',
						),
						'--outline-cta-background': 'transparent',
						'--outline-cta-background-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--outline-cta-border': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--outline-cta-border-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--outline-cta-default': 0,
						// '--logo': '#fff',
						// '--logo2': 'transparent',
						'--search': gsap.getProperty(header, '--header-mobile-nav-link'),
						'--search-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-icons-hover',
						),
						'--menu-trigger-border': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--menu-trigger-fill': 'transparent',
						'--menu-trigger-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--menu-trigger-bar': gsap.getProperty(
							header,
							'--header-mobile-nav-link',
						),
						'--menu-trigger-bar-hover': gsap.getProperty(
							header,
							'--header-mobile-nav-icons-hover',
						),
						'--background':
							!header.classList.contains('v-header--stuck') && isReversed
								? 'transparent'
								: '#fff',
						duration: 0.2,
					},
					isReversed && !header.classList.contains('v-header--stuck')
						? 'background-in'
						: 'background-in-=0.2',
				)
				// .to(
				// 	header,
				// 	{
				// 		'--logo': '#fff',
				// 		duration: 0.4,
				// 	},
				// 	'<',
				// )
				// .to(
				// 	header,
				// 	{
				// 		'--logo2': 'transparent',
				// 		duration: 0,
				// 	},
				// 	'<',
				// )
				.to(
					'#full-logo',
					{
						autoAlpha: 0,
						delay: 0,
						duration: 0.1,
					},
					'<',
				)
				.to(
					'#full-logo',
					{
						display: 'none',
					},
					'<',
				)
				.to(
					'#logo-icon path',
					{
						fill: '#ffffff',
						duration: 0,
					},
					'<',
				)
				.to(
					'#logo-icon',
					{
						autoAlpha: 0,
					},
					'<',
				)
				.to(
					'#logo-icon',
					{
						display: 'block',
						delay: 0,
					},
					'>',
				)
				.to(
					'#logo-icon',
					{
						autoAlpha: 1,
						duration: 0.1,
					},
					'<',
				)
				.to(
					'.v-header-gradient',
					{
						'--gradient-opacity': 0,
						duration: 0.2,
					},
					'<',
				)
				.to(
					'.v-mobile-menu__overlay',
					{
						opacity: 1,
						duration: 0.2,
					},
					'<',
				)
				.to(
					'.v-header__main-menu',
					{
						opacity: 0,
						onComplete: () => {
							gsap.set('.v-header__main-menu', { pointerEvents: 'none' });
						},
						onReverseComplete: () => {
							gsap.set('.v-header__main-menu', { pointerEvents: 'all' });
						},
					},
					'start',
				)
				.to(
					'.v-header__menu-trigger-bar',
					{
						'--offset': 0,
						'--scale': 1.41666667,
						duration: 0.2,
					},
					'start',
				)
				.to(
					'.v-header__menu-trigger-bar:nth-child(2)',
					{
						opacity: 0,
						duration: 0,
					},
					'>',
				)
				.to(
					'.v-header__menu-trigger-bar:nth-child(1)',
					{
						'--rotate': '-45deg',
						duration: 0.2,
					},
					'<',
				)
				.to(
					'.v-header__menu-trigger-bar:nth-child(3)',
					{
						'--rotate': '45deg',
						duration: 0.2,
					},
					'<',
				)
				.to(
					'.v-mobile-menu__wrap',
					{
						opacity: 1,
					},
					'background-in+=0.1',
				);

		/**
		 * Open mobile menu.
		 */
		const openMobileMenu = () => {
			const { scrollY } = window;
			mobileMenu.classList.add('v-mobile-menu--open');
			setHeights();
			// setScrollIndicators();
			gsap.set('body', {
				position: 'fixed',
				top: `-${scrollY}px`,
				overflowY: 'scroll',
			});
			gsap.set('.v-hp-hero__background', {
				opacity: 0,
			});
			if (!headerTl) {
				headerTl = generateHeaderTl();
			}

			headerTl.play();
		};

		/**
		 * Close mobile menu.
		 */
		const closeMobileMenu = () => {
			gsap.to('.v-hp-hero__background', {
				opacity: 1,
				duration: 0.7,
			});
			if (headerTl) {
				headerTl.reverse();
			}
		};

		/**
		 * Handle trigger click.
		 */
		const handleClick = () => {
			const stickyTransitioning = header.classList.contains(
				'v-header--stick-transition',
			);

			if (stickyTransitioning) return;

			isOpen = !isOpen;

			if (isOpen) {
				const e = new CustomEvent('v-mobile-menu-toggle', {
					detail: {
						open: isOpen,
					},
				});
				window.dispatchEvent(e);

				const waitForEvents = [];
				if (header.classList.contains('v-header--dropdown-open')) {
					waitForEvents.push({
						name: 'v-main-menu',
						detail: 'open',
						value: false,
					});
				}

				if (
					header.classList.contains('v-header--stuck') ||
					header.classList.contains('v-header--stick-transition')
				) {
					waitForEvents.push({
						name: 'v-sticky-header',
						detail: 'stuck',
						value: false,
					});
				}

				if (header.classList.contains('v-header--stick-color-transition')) {
					waitForEvents.push({
						name: 'v-sticky-header-color',
						detail: 'stuck',
						value: 'any',
					});
				}

				if (waitForEvents.length) {
					let dispatched = false;
					const waitingFor = waitForEvents.map((event) => event.name);

					waitForEvents.forEach((event) => {
						/**
						 * Wait for header to unstick.
						 * @param {Event} ev - Sticky header event.
						 */
						const waitForUnstick = (ev) => {
							if (
								event.value !== 'any' &&
								ev.detail[event.detail] === event.value
							) {
								waitingFor.splice(waitingFor.indexOf(event.name), 1);
								window.removeEventListener(event.name, waitForUnstick);

								if (!waitingFor.length && !dispatched) {
									dispatched = true;
									openMobileMenu();
								}
							}
						};
						window.addEventListener(event.name, waitForUnstick);
					});
				} else {
					openMobileMenu();
				}
			} else {
				if (subSubnavTl) {
					subSubnavTl.reverse();
				}

				if (subnavTl) {
					subnavTl.reverse();
				}
				closeMobileMenu();
			}
		};

		mobileTrigger.addEventListener('click', handleClick);

		return () => {
			if (headerTl) {
				const targets = headerTl
					.getChildren()
					.map((t) => t.targets())
					.flat()
					.filter((e) => e !== header);
				headerTl.progress(0);
				gsap.set(targets, { clearProps: 'all' });
			}

			if (subSubnavTl) {
				const targets = subSubnavTl
					.getChildren()
					.map((t) => t.targets())
					.flat()
					.filter((e) => e !== header);
				subSubnavTl.progress(0);
				gsap.set(targets, { clearProps: 'all' });
			}

			if (subnavTl) {
				const targets = subnavTl
					.getChildren()
					.map((t) => t.targets())
					.flat()
					.filter((e) => e !== header);
				subnavTl.progress(0);
				gsap.set(targets, { clearProps: 'all' });
			}

			gsap.set('.v-mobile-menu__background', {
				transformOrigin: 'right center',
				scaleX: 0,
			});

			gsap.set('.v-mobile-menu__wrap', {
				opacity: 0,
			});

			gsap.set('.v-mobile-menu__overlay', {
				opacity: 0,
			});

			if (gsap.getProperty('body', 'position') === 'fixed') {
				const scrollY = gsap.getProperty('body', 'top');
				gsap.set('body', {
					position: '',
					top: '',
					overflowY: '',
				});
				window.scrollTo(0, parseInt(scrollY || '0', 10) * -1);
			}

			if (isOpen) {
				isOpen = false;
				mobileMenu.classList.remove('v-mobile-menu--open');
				const e = new CustomEvent('v-mobile-menu-toggle', {
					detail: {
						open: isOpen,
					},
				});
				window.dispatchEvent(e);
			}

			mobileTrigger.removeEventListener('click', handleClick);
		};
	};

	mm.add('(max-width: 767px)', mobileMenuHandler);
	mm.add('(min-width: 768px) and (max-width: 1439px)', mobileMenuHandler);
};

export default vMobileMenu;
